import React from 'react';
import './ForYou.scss';
import { safeHtml } from '../../../../services/helpers';

export default function ForYou({ content }) {
    return (
        <div className="workshop-for_you" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
    )
}
